import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/landing';

/**
 * nirvik.ai router scaffold.
 *
 * Only `/` is wired up today — other routes (about, company, contact,
 * /labs standalone) slot in here as we add pages. Keeping Router in place
 * from day one avoids churn when the first sub-page arrives. */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
    </Routes>
  );
}
